import React, { useState } from 'react';
import Button from '../../../shared/components/Button';

const GroupBasics = ({ data, onNext, onBack }) => {
  const [groupName, setGroupName] = useState(data?.groupName || '');
  const [culturalTerm, setCulturalTerm] = useState(data?.culturalTerm || '');
  const [errors, setErrors] = useState({});

  const culturalTerms = [
    { value: 'esusu', label: 'Esusu' },
    { value: 'ajo', label: 'Ajo' },
    { value: 'sol', label: 'Sol' },
    { value: 'sòl', label: 'Sòl' },
    { value: 'susu', label: 'Susu' },
    { value: 'partner', label: 'Partner' },
    { value: 'tanda', label: 'Tanda' },
    { value: 'other', label: 'Other' }
  ];

  const validateForm = () => {
    const newErrors = {};
    
    if (!groupName.trim()) {
      newErrors.groupName = 'Group name is required';
    }
    
    if (!culturalTerm) {
      newErrors.culturalTerm = 'Please select a cultural term';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      onNext({
        groupName: groupName.trim(),
        culturalTerm
      });
    }
  };

  return (
    <div className="flex flex-col min-h-screen px-4 py-8 bg-neutral-100">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-neutral-900 mb-2">
          Let's set up your group basics
        </h1>
        <p className="text-neutral-600">
          Choose a name and cultural term that resonates with your community
        </p>
      </div>

      {/* Form */}
      <div className="flex-1 space-y-6">
        {/* Group Name */}
        <div>
          <label htmlFor="groupName" className="block text-sm font-medium text-neutral-700 mb-2">
            Group Name *
          </label>
          <input
            type="text"
            id="groupName"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            placeholder="Enter your group name"
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent ${
              errors.groupName ? 'border-error-500' : 'border-neutral-300'
            }`}
          />
          {errors.groupName && (
            <p className="mt-1 text-sm text-error-600">{errors.groupName}</p>
          )}
        </div>

        {/* Cultural Term */}
        <div>
          <label htmlFor="culturalTerm" className="block text-sm font-medium text-neutral-700 mb-2">
            Cultural Term *
          </label>
          <select
            id="culturalTerm"
            value={culturalTerm}
            onChange={(e) => setCulturalTerm(e.target.value)}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent ${
              errors.culturalTerm ? 'border-error-500' : 'border-neutral-300'
            }`}
          >
            <option value="">Select a cultural term</option>
            {culturalTerms.map(term => (
              <option key={term.value} value={term.value}>
                {term.label}
              </option>
            ))}
          </select>
          {errors.culturalTerm && (
            <p className="mt-1 text-sm text-error-600">{errors.culturalTerm}</p>
          )}
          
          {/* Cultural Term Info */}
          {culturalTerm && (
            <div className="mt-3 p-3 bg-primary-50 rounded-lg">
              <p className="text-sm text-primary-800">
                This term will adapt all language throughout the app to match your cultural context.
              </p>
            </div>
          )}
        </div>

        {/* Cultural Terms Description */}
        <div className="mt-6 p-4 bg-neutral-50 rounded-lg">
          <h3 className="text-sm font-medium text-neutral-700 mb-2">About Cultural Terms</h3>
          <div className="space-y-1 text-xs text-neutral-600">
            <p><strong>Esusu/Ajo/Susu:</strong> West African rotating savings</p>
            <p><strong>Sol/Sòl:</strong> Caribbean rotating savings</p>
            <p><strong>Partner:</strong> Jamaican rotating savings</p>
            <p><strong>Tanda:</strong> Latin American rotating savings</p>
            <p><strong>Other:</strong> Your community's specific term</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <div className="flex space-x-3 mt-8">
        <Button
          onClick={onBack}
          variant="secondary"
          className="flex-1"
        >
          Back
        </Button>
        <Button
          onClick={handleSubmit}
          variant="primary"
          className="flex-1"
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default GroupBasics;
